import "../reportDashboard.scss";

// items: [{ label, value, tone, labelTone, subtitle, badge, badgeTone, onClick }]
// `labelTone` is optional — a label stays muted unless the caller asks for a tone.
// `tone` is a semantic name ("kudos" | "corrective" | "action" | "reprimand" |
// "danger" | "warning" | "accent" | "muted"), never a colour — reportDashboard.scss
// resolves it against the palette in scss/_variables.scss. `onClick` is optional —
// cards without it render as plain, non-interactive stat cards. `badge` renders
// in normal flow below the subtitle (not absolutely positioned); `badgeTone`
// picks its colour ("danger" | "warning"), defaulting to "danger".
const StatCardRow = ({ items, columns = 4, inner = false }) => (
  <div
    className={inner ? "rdStatRow rdStatRow--inner" : "rdStatRow"}
    style={{ "--rd-stat-cols": columns }}
  >
    {items.map((item) => (
      <div
        className={[
          "rdStatCard",
          `is-${item.tone || "accent"}`,
          item.onClick ? "rdStatCard--clickable" : "",
        ]
          .filter(Boolean)
          .join(" ")}
        key={item.label}
        onClick={item.onClick}
      >
        <div
          className={[
            "rdStatCard__label",
            item.labelTone ? `is-${item.labelTone}` : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {item.label}
        </div>
        <div className={`rdStatCard__value is-${item.tone || "accent"}`}>
          {item.value}
        </div>
        {item.subtitle && (
          <div className="rdStatCard__subtitle">{item.subtitle}</div>
        )}
        {item.badge && (
          <span
            className={`rdStatCard__badge rdStatCard__badge--${item.badgeTone || "danger"}`}
          >
            {item.badge}
          </span>
        )}
      </div>
    ))}
  </div>
);

export default StatCardRow;
